import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';



// Define an interface for the inventory item structure
export interface InventoryItem {
  subCategory: string;
  rollNo: string;
  category: string;
  subcategory: string;
  thicknessMicron?: string;
  sizeMM?: string;
  color?: string;
  inkType?: string;
  materialTypeGrade?: string;
  supplier: string;
  receivedDate: string;
  materialDescription: string;
  qty: number;  // Quantity in Kg
  location: string;
}






@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  // private apiUrl = "http://localhost:3003/api/In";
   apiUrl = "https://lexipackghana.com:3003/api/In";

  constructor(private http: HttpClient) { }

  createInventry(invenData: any) {
    return this.http.post(this.apiUrl+'/addIn', invenData);
  }
  
  
    // Retrieve all MatMix entries
    // getAllInventry(){
    //   return this.http.get(this.apiUrl+'/getAllIn');
    // }
    //for fetching data(matrollno)
    // Retrieve all inventory items 
  getAllInventry(): Observable<InventoryItem[]> {
    return this.http.get<InventoryItem[]>(this.apiUrl + '/getAllIn');
  }
  
    // Retrieve a MatMix entry by its ID
    getInventryById(invenId: string) {
  
      return this.http.get(this.apiUrl+'/getByIdIn/'+invenId);
  
    }
    updateInventry(invenId: string,data:String) {
  
      return this.http.put(this.apiUrl+'/putByIdIn/'+invenId,data);
  
    }
    deleteInventry(invenId: string) {
      return this.http.delete(this.apiUrl+'/deleteByIdIn/'+invenId);
    }

}
